import React, { useState } from 'react'
import Navbar from './Navbar'
import NavbarTabs from './NavbarTabs'
import SideBar from './sideBar/SideBar'

export default function RootLayout({ children }) {
  const [navMenuOpen, setNavMenuOpen] = useState(false)
  const [childrens, setChildrens] = useState(null)

  return (
    <div className='flex h-screen w-full overflow-hidden'>
      <SideBar
        navMenuOpen={navMenuOpen}
        setNavMenuOpen={setNavMenuOpen}
        childrens={childrens}
        setChildrens={setChildrens}
      />
      <div className='flex flex-col flex-1 h-full overflow-hidden'>
        <div className='min-h-[50px] w-full'>
          <Navbar
            navMenuOpen={navMenuOpen}
            setNavMenuOpen={setNavMenuOpen}
            childrens={childrens}
            setChildrens={setChildrens}
          />
          <NavbarTabs
            childrens={childrens}
            setChildrens={setChildrens}
            setNavMenuOpen={setNavMenuOpen}
          />
        </div>
        <div className='flex-1 overflow-y-auto px-4 pt-2 pb-4'>{children}</div>
      </div>
    </div>
  )
}
